const revenues = {
  header: {
    helper: {
      title: 'be.revenue_list.helper.title',
      description: [
        'be.revenue_list.helper.text_1',
        'be.revenue_list.helper.text_2',
        'be.revenue_list.helper.text_3',
        'be.revenue_list.helper.text_4',
        'be.revenue_list.helper.text_5',
      ],
      ctaDesc: 'question_on_topic',
      ctaText: 'talk_to_an_expert',
      onClick: (): void => {}, // To be replaced with Intercom call
    },
  },
};

export default revenues;
